import { DataSort } from '../models/configuration/DataSort';
import get from 'lodash/get';

export const sortDate = (a: string | number, b: string | number) => {
    const aDate = new Date(a);
    const bDate = new Date(b);

    return Number(aDate) - Number(bDate);
};

export const sortNumber = (a: number, b: number) => {
    return a - b;
};

export const sortString = (a: string, b: string) => {
    const aString = a.toString().toUpperCase();
    const bString = b.toString().toUpperCase();

    if (aString > bString) {
        return 1;
    }

    if (aString < bString) {
        return -1;
    }

    return 0;
};

export const sortValues = (values: Array<any>, config: DataSort) => {
    if (values && values.length > 0) {
        if (config && config.type === 'date') {
            values = values.sort((a, b) =>
                sortDate(
                    get(a, config.key, '2099-01-01'),
                    get(b, config.key, '2099-01-01')
                )
            );
        }

        if (config && config.type === 'string') {
            values = values.sort((a, b) =>
                sortString(get(a, config.key, '~'), get(b, config.key, '~'))
            );
        }

        if (config && config.type === 'number') {
            values = values.sort((a, b) =>
                sortNumber(
                    get(a, config.key, Number.MAX_VALUE),
                    get(b, config.key, Number.MAX_VALUE)
                )
            );
        }

        // Sort direction
        if (config && config.direction === 'DESC') {
            values = values.reverse();
        }

        // Sort by a specified order
        if (config && config.order && config.order.length > 0) {
            values = values
                .map(value => {
                    const orderIndex = config.order.indexOf(value[config.key]);
                    value.order =
                        orderIndex > -1 ? orderIndex : config.order.length;
                    return value;
                })
                .sort((a, b) => sortNumber(a.order, b.order));
        }
    }
    return values;
};



// WEBPACK FOOTER //
// ./src/utils/sort.ts